import { Helmet } from 'react-helmet';

import MenuWithLogo from '~/modules/elements/menu-with-logo';
import useSmoothNavigate from '~/modules/hooks/use-smooth-navigate';
import SelectInputView, { MIC_SETUP_CARD } from '~/routes/select-input/select-input-view';

function SelectInput() {
  const navigate = useSmoothNavigate();
  const goToMenu = () => navigate('menu/');

  return (
    <MenuWithLogo logo={false} centered className={MIC_SETUP_CARD} data-test="mic-setup-page">
      <Helmet>
        <title>Select Input | AllKaraoke.Party - Free Online Karaoke Party Game</title>
      </Helmet>
      <SelectInputView onFinish={goToMenu} canGoBack />
    </MenuWithLogo>
  );
}
export default SelectInput;
